/**
 * Offline-readiness for the dashboard app tiles.
 *
 * An app is usable offline only when BOTH are true:
 *   1. a service worker controls the page — the build (every role chunk) is
 *      precached, so the app's code can load offline; and
 *   2. the app has LOCAL DATA — `persist:<app>-root` exists in localStorage,
 *      which only happens once the app has been opened online at least once
 *      (its settings + plays were fetched and persisted).
 *
 * The SW precaches every app's CHUNK, but a never-opened app has no DATA — it
 * would open into empty settings offline — so it must stay greyed (wifi icon)
 * until it's been opened online once. (Mirrors the in-game dashboard, which
 * gates offline access on `persist:root-<app>` existing.)
 */

export function isOfflineReady(appId: string): boolean {
  try {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return false;
    }
    if (navigator.serviceWorker.controller == null) return false;
    return localStorage.getItem(`persist:${appId}-root`) != null;
  } catch {
    return false;
  }
}
